export const getTipoCarga = (carga: Record<string, any>) => {
  if (!carga.j14_018_n) {
    return "Indeterminada";
  }
  switch (carga.j14_018_n * 1) {
    case 1:
      return "Cadastrada";
    case 2:
      return "Batida";
    case 3:
      return "Paletizada";
    case 4:
      return "Big Bag";
    case 5:
      return "Granel";
    case 6:
      return "Farelo";
    default:
      return "Indeterminada";
  }
};